import { render, staticRenderFns } from "./DocumentKPLH.vue?vue&type=template&id=b369975e&"
import script from "./DocumentKPLH.vue?vue&type=script&lang=js&"
export * from "./DocumentKPLH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports